import NativeProxy from '@cvte/native-proxy';

const nativeProxy = new NativeProxy({
  context: 'enApp',
  log: false,
});
export default nativeProxy;
